import { ReturnsCoverageSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-coverage-settings/returns-coverage-settings";
import { ReturnsLabelsSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-labels-settings";
import { ReturnsLocationsSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-locations-settings";
import { ReturnsOperationsSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-operations-settings";
import { ReturnsPoliciesSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-policies-settings";
import { ReturnsPortalSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-portal-settings";
import { ReturnsShopperNotificationsSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-shopper-notifications-settings";
import { ReturnsWarehouseSettingsChangesSchema } from "@redotech/redo-return-settings-common/returns-warehouse-settings";
import * as z from "zod";

/** Changed fields per tab of the consolidated returns settings page; omitted fields are untouched. */
export const updateReturnsSettings = {
  name: "updateReturnsSettings" as const,
  input: z.object({
    operations: ReturnsOperationsSettingsChangesSchema.optional(),
    coverage: ReturnsCoverageSettingsChangesSchema.optional(),
    policies: ReturnsPoliciesSettingsChangesSchema.optional(),
    labels: ReturnsLabelsSettingsChangesSchema.optional(),
    locations: ReturnsLocationsSettingsChangesSchema.optional(),
    portal: ReturnsPortalSettingsChangesSchema.optional(),
    warehouse: ReturnsWarehouseSettingsChangesSchema.optional(),
    shopperNotifications:
      ReturnsShopperNotificationsSettingsChangesSchema.optional(),
  }),
  output: z.object({}),
};
